import React from 'react';

export type Props = {
  className?: string;
  height?: number;
  onClick?(): void;
  width?: number;
};
export const TiktokCircle = React.memo((props: Props) => {
  return (
    <svg
      width={props.width || 40}
      height={props.height || 40}
      className={props.className}
      onClick={props.onClick}
      viewBox='0 0 40 40'
    >
      <g fill='none'>
        <rect width='40' height='40' rx='20' fill='white'/>
        <circle cx='20' cy='20' r='12' fill='var(--footer-social-icons-color)' strokeWidth='0px' />
        <path d='M27.39,18.47c-.14.01-.27.02-.41.02-.74,0-1.48-.19-2.13-.54-.65-.35-1.21-.86-1.62-1.49v6.9c0,1.01-.3,1.99-.86,2.83-.56.84-1.36,1.49-2.29,1.88-.93.39-1.96.49-2.95.29-.99-.2-1.9-.68-2.61-1.4-.71-.71-1.2-1.62-1.4-2.61-.2-.99-.1-2.01.29-2.95.39-.93,1.04-1.73,1.88-2.29.84-.56,1.82-.86,2.83-.86.11,0,.21,0,.32.02v2.51c-.1-.01-.21-.03-.32-.03-.69,0-1.35.27-1.84.76-.49.49-.76,1.15-.76,1.84s.27,1.35.76,1.84c.49.49,1.15.76,1.84.76,1.44,0,2.71-1.13,2.71-2.57l.03-11.72h2.4c.11,1.04.58,2.02,1.34,2.75.75.73,1.74,1.17,2.79,1.25v2.79' fill='white' strokeWidth='0px' />
      </g>
    </svg>
  );
});

TiktokCircle.displayName = 'TiktokCircle';
